import "core-js/modules/es.array.push.js";
import { buildSearchBox, buildResultList, buildNotifyTrigger } from '@coveo/headless';
import { SearchIcon } from '../../commerce/blocks/svg-elements/search-icon-new';
import { CloseIcon } from '../../commerce/blocks/svg-elements/close-icon';
export default {
  data: function () {
    return {
      initEngine: true,
      controller: null,
      count: 0,
      inputValue: '',
      selectedSearchValue: '',
      resultController: null,
      qTimer: undefined,
      searchResults: [],
      searchResultspdpurl: [],
      searchResultIndex: -1,
      searchResponded: false,
      notifyController: null,
      blockingNotifications: [],
      useV2Features: false,
      selectedProducts: [],
      maxSelectedProducts: 10,
      minSuggestionChars: 2,
      controllerSubscribed: false,
      pendingUrlProduct: null
    };
  },
  components: {
    SearchIcon,
    CloseIcon
  },
  computed: {
    isSelectionFull() {
      return this.useV2Features && this.selectedProducts.length >= this.maxSelectedProducts;
    },
    pdpUrlProducts() {
      return this.useV2Features ? this.selectedProducts.filter(p => p.pdpUrl) : this.searchResultspdpurl;
    },
    selectedCountLabel() {
      return Granite.I18n.get('search.selectedProducts.count', [this.selectedProducts.length, this.maxSelectedProducts]);
    },
    cantFindProductLabel() {
      return Granite.I18n.get('search.selectedProducts.cantFind');
    },
    sourceSearchLabel() {
      return Granite.I18n.get('search.selectedProducts.source.search');
    },
    sourceAutoLabel() {
      return Granite.I18n.get('search.selectedProducts.source.auto');
    },
    techContentLabel() {
      return Granite.I18n.get('search.selectedProducts.techContent');
    },
    searchLabel() {
      return Granite.I18n.get('button.search.Title');
    },
    searchEngine() {
      return this.$store.state.search.engine;
    },
    state() {
      this.count;
      return this.controller?.state;
    },
    resultState() {
      this.count;
      return this.resultController?.state;
    }
  },
  methods: {
    // the "product" URL parameter: "+" decoded as a space, control
    // characters (e.g. %0B) replaced, whitespace collapsed
    readUrlProduct() {
      const value = new URLSearchParams(window.location.search).get('product');
      return (value || '').replace(/[\u0000-\u001F\u007F]+/g, ' ').replace(/\s+/g, ' ').trim();
    },
    // text typed but not picked from the dropdown is added as if
    // "I can't find my product" was clicked (review & submit)
    commitTypedProduct() {
      this.addTypedProduct();
      this.updateProductFields(this.selectedProducts.map(p => p.rawValue));
    },
    getProductField() {
      let field = null;
      guideBridge.visit(component => {
        if (!field && component.name === 'textbox-product') {
          field = component;
        }
      });
      return field;
    },
    updateText(inputValue) {
      this.updateProductFields([inputValue]);
    },
    updateProductFields(values) {
      if (typeof guideBridge === 'undefined') return;
      // the form may not be initialized yet (e.g. URL product added on
      // mount); connect runs the callback once it is, or right away
      guideBridge.connect(() => {
        const field = this.getProductField();
        if (!field) return;
        guideBridge.setProperty([field.somExpression], 'value', [values.filter(Boolean).join(', ')]);
        // the form only fires elementValueChanged when a value changes;
        // a URL product resolving to a PDP keeps the same name, so
        // tell listeners (remove.js) to re-evaluate either way
        document.dispatchEvent(new CustomEvent('aem-forms-search-box:products-updated'));
        if (values.some(Boolean)) {
          $('#aem-forms-search-box-error')?.css('display', 'none');
        } else {
          $('#aem-forms-search-box-error')?.css('display', 'block');
        }
      });
    },
    submit() {
      if (this.isSelectionFull) return;
      const text = this.inputValue.trim();
      if (this.useV2Features && this.searchResultIndex == -1 && text && this.searchResponded && !this.searchResults.length) {
        clearTimeout(this.qTimer);
        this.addSelectedProduct({
          rawValue: text
        });
      } else if (this.searchResultIndex != -1) {
        this.selectSearchValue(this.searchResults[this.searchResultIndex].rawValue);
      } else {
        this.runSearch(this.inputValue);
      }
    },
    addTypedProduct() {
      const text = this.inputValue.trim();
      if (!text || this.isSelectionFull) return;
      clearTimeout(this.qTimer);
      this.addSelectedProduct({
        rawValue: text
      });
    },
    runSearch(text) {
      if (!this.controller) return;
      if (!this.controllerSubscribed) {
        this.controller.subscribe(() => this.count++);
        this.controllerSubscribed = true;
      }
      this.controller.updateText(text);
      this.controller.submit();
    },
    isSameProduct(a, b) {
      return a.rawValue.trim().toLowerCase() === b.rawValue.trim().toLowerCase();
    },
    async addSelectedProduct(product) {
      if (this.blockingNotifications.length) return;
      this.inputValue = '';
      this.searchResults = [];
      this.searchResponded = false;
      this.searchResultIndex = -1;
      this.$refs.searchboxInputRef?.focus();
      if (!product || this.selectedProducts.length >= this.maxSelectedProducts || this.selectedProducts.some(p => this.isSameProduct(p, product))) {
        return;
      }
      this.selectedProducts.push(product);
      if (product.productCode) {
        await this.$store.dispatch('product/fetchProductAttributes', {
          productCodes: product.productCode,
          fields: 'categories,businesses,businessgroups'
        });
      }
    },
    resolveUrlProduct() {
      const pending = this.pendingUrlProduct;
      this.pendingUrlProduct = null;
      const match = this.searchResults.find(result => this.isSameProduct(result, pending));
      this.searchResults = [];
      this.searchResponded = false;
      this.searchResultIndex = -1;
      const index = this.selectedProducts.indexOf(pending);
      if (index !== -1 && this.blockingNotifications.length) {
        this.selectedProducts.splice(index, 1);
        return;
      }
      if (!match || index === -1) return;
      this.selectedProducts.splice(index, 1, match);
      this.$store.dispatch('product/fetchProductAttributes', {
        productCodes: match.productCode,
        fields: 'categories,businesses,businessgroups'
      });
    },
    removeSelectedProduct(product) {
      this.selectedProducts = this.selectedProducts.filter(p => p !== product);
      this.$nextTick(() => this.$refs.searchboxInputRef?.focus());
    },
    async selectSearchValue(selectedValue) {
      if (this.useV2Features) {
        return this.addSelectedProduct(this.searchResults.find(result => result.rawValue === selectedValue));
      }
      this.inputValue = selectedValue;
      this.selectedSearchValue = selectedValue;

      // Get the clicked result's data
      const selectedResult = this.searchResults.find(result => result.rawValue === selectedValue);
      if (selectedResult) {
        const productCode = selectedResult.productCode;
        await this.$store.dispatch('product/fetchProductAttributes', {
          productCodes: productCode,
          fields: 'categories,businesses,businessgroups'
        });
      }
    },
    clearSearchTerm() {
      this.inputValue = '';
      this.searchResults = [];
      this.searchResponded = false;
      this.searchResultspdpurl = [];
      this.blockingNotifications = [];
      this.controller.clear();
    },
    hideSearchResults(e) {
      setTimeout(() => {
        this.searchResults = [];
        this.searchResponded = false;
        this.searchResultIndex = -1;
      }, 300);
    },
    selectSearchResults(e) {
      if (e.which === 40) {
        this.$refs.searchboxInputRef.focus();
        if (this.searchResultIndex != -1) {
          var previousEl = document.getElementById('searchResult' + this.searchResultIndex);
          if (previousEl != null) {
            previousEl.classList.remove('suggestionHover');
            this.searchResultIndex++;
          }
        } else {
          this.searchResultIndex++;
        }
        var el = document.getElementById('searchResult' + this.searchResultIndex);
        if (el != null && this.searchResults[this.searchResultIndex]) {
          el.classList.add('suggestionHover');
        } else if (this.searchResults.length - 1 < this.searchResultIndex) {
          this.searchResultIndex = 0;
          el = document.getElementById('searchResult' + this.searchResultIndex);
          el.classList.add('suggestionHover');
        }
      } else if (e.which === 38) {
        this.$refs.searchboxInputRef.focus();
        if (this.searchResultIndex != -1) {
          var previousEl = document.getElementById('searchResult' + this.searchResultIndex);
          if (previousEl != null) {
            previousEl.classList.remove('suggestionHover');
            this.searchResultIndex--;
          }
        }
        var el = document.getElementById('searchResult' + this.searchResultIndex);
        if (el != null && this.searchResultIndex != -1) {
          el.classList.add('suggestionHover');
        } else if (this.searchResultIndex == -1) {
          this.searchResultIndex = this.searchResults.length - 1;
          el = document.getElementById('searchResult' + this.searchResultIndex);
          el.classList.add('suggestionHover');
        }
      }
    }
  },
  watch: {
    searchEngine(newVal, oldVal) {
      if (newVal) {
        this.resultController = buildResultList(this.searchEngine);
        this.resultController.subscribe(() => this.count++);
        if (this.useV2Features) {
          this.notifyController = buildNotifyTrigger(this.searchEngine);
        }
      }
    },
    resultState(newVal, oldVal) {
      if (oldVal && newVal.searchResponseId != oldVal.searchResponseId) {
        // V2 only: a notify trigger (e.g. a discontinued brand) blocks
        // adding the product; banners are left to the search page
        this.blockingNotifications = this.useV2Features ? (this.notifyController?.state.notifications || []).filter(n => !n.startsWith('Execute showBanner(')) : [];
        this.searchResults = [];
        this.resultState.results.forEach(element => {
          let searchResult = {
            highlightedValue: element.title,
            rawValue: element.title,
            pdpUrl: element.uri,
            productCode: element.raw?.permanentid
          };
          this.searchResults.push(searchResult);
          this.searchResultspdpurl = this.searchResults;
        });
        if (this.pendingUrlProduct) {
          this.resolveUrlProduct();
        } else {
          this.searchResponded = true;
        }
      }
    },
    controller(newVal) {
      if (newVal && this.pendingUrlProduct) {
        this.runSearch(this.pendingUrlProduct.rawValue);
      }
    },
    selectedSearchValue(newVal, oldVal) {
      this.hideSearchResults();
    },
    inputValue(newVal, oldVal) {
      if (newVal !== oldVal) {
        clearTimeout(this.qTimer);
        this.qTimer = setTimeout(() => {
          if (!this.useV2Features) {
            this.updateText(this.inputValue);
            return;
          }
          if (this.inputValue.trim().length >= this.minSuggestionChars) {
            this.runSearch(this.inputValue);
          } else {
            this.searchResults = [];
            this.searchResponded = false;
            this.blockingNotifications = [];
            this.searchResultIndex = -1;
          }
        }, 300);
      }
    },
    selectedProducts: {
      deep: true,
      flush: 'post',
      handler(products) {
        this.updateProductFields(products.map(p => p.rawValue));
      }
    }
  },
  created() {
    if (this.initEngine) {
      var params = {
        hub: 'DowComMainSearch',
        customFilter: '@source=Product'
      };
      this.$store.dispatch('search/fetchSearchToken', params).then(result => {
        if (result === -1) {
          console.log('Error during building Coveo search engine: Failed to fetch search token');
        } else {
          this.$store.dispatch('search/updateEngine').then(function () {
            this.controller = buildSearchBox(this.searchEngine);
          }.bind(this));
        }
      });
    }
  },
  async mounted() {
    const teleportTarget = document.querySelector('[aem-forms-search-box]');
    if (teleportTarget) {
      this.useV2Features = Object.hasOwn(teleportTarget.dataset, 'useV2Features');
    }

    // product presented in URL: V2 adds it straight to the list,
    // otherwise it fills the textbox
    const urlProduct = this.readUrlProduct();
    if (urlProduct) {
      if (this.useV2Features) {
        // show the pill right away, then look it up in Coveo so it
        // gets the product code / PDP url when it resolves to one
        const product = {
          rawValue: urlProduct
        };
        this.selectedProducts.push(product);
        this.pendingUrlProduct = product;
        if (this.controller) {
          this.runSearch(urlProduct);
        }
      } else {
        this.inputValue = urlProduct;
      }
    }
    if (this.useV2Features) {
      document.addEventListener('aem-forms-search-box:commit-typed', this.commitTypedProduct);
    }
  },
  beforeUnmount() {
    document.removeEventListener('aem-forms-search-box:commit-typed', this.commitTypedProduct);
  }
};